import React from 'react'

/** A context providing DS API-specific information */
export const DSAPIContext = React.createContext<{
  apiURL: string
}>({ apiURL: '' })

/**
 * A high-level provider which coordinates calls to DS API. In the future,
 * advanced caching/editing might be supported via this provider.
 * @param apiURL      The URL of the DS API to use (dev, prod, etc.)
 * @param children    Children of this component
 * @constructor
 */
export const DSAPIProvider: React.FC<{
  apiURL: string
  children: React.ReactNode
}> = ({ apiURL, children }) => (
  <DSAPIContext.Provider value={{ apiURL }}>{children}</DSAPIContext.Provider>
)
